(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-bolovo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-footer-bolovo-back-to-top]')) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const pin = event.target.closest('.lookbook-tag__pin');
    const openTag = document.querySelector('.lookbook-tag[data-open]');

    if (pin) {
      event.preventDefault();
      event.stopPropagation();

      const tag = pin.closest('.lookbook-tag');
      const wasOpen = tag.hasAttribute('data-open');

      if (openTag && openTag !== tag) openTag.removeAttribute('data-open');

      if (wasOpen) {
        tag.removeAttribute('data-open');
      } else {
        tag.setAttribute('data-open', '');
      }

      return;
    }

    if (openTag && !event.target.closest('.lookbook-tag')) {
      openTag.removeAttribute('data-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openTag = document.querySelector('.lookbook-tag[data-open]');
    if (openTag) openTag.removeAttribute('data-open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-scroll-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-scroll-gallery')) {
    class LpScrollGallery extends HTMLElement {
      // campos no constructor (sem class fields) pra rodar no Safari/iOS antigo
      constructor() {
        super();
        this._frame = 0;
        this._distance = 0;
        this._schedule = () => {
          if (this._frame) return;
          this._frame = requestAnimationFrame(() => {
            this._frame = 0;
            this._update();
          });
        };
        this._measure = () => {
          // quanto a fileira passa da largura da tela = quanto de scroll vertical a seção "consome"
          const viewport = this.querySelector('.lp-scroll-gallery__viewport');
          const track = this.querySelector('.lp-scroll-gallery__track');
          const sticky = this.querySelector('.lp-scroll-gallery__sticky');
          const styles = getComputedStyle(viewport);
          const inner = viewport.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
          this._distance = Math.max(0, track.scrollWidth - inner);
          // mobile não fixa: sem altura extra
          this.style.height = this._isMobile() ? '' : `${sticky.offsetHeight + this._distance}px`;
          this._schedule();
        };
      }

      connectedCallback() {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.resizeObserver = new ResizeObserver(this._measure);
        this.resizeObserver.observe(this.querySelector('.lp-scroll-gallery__track'));
        this.resizeObserver.observe(this.querySelector('.lp-scroll-gallery__sticky'));
        window.addEventListener('resize', this._measure, { passive: true });

        // só escuta scroll enquanto a seção está perto da tela
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            // capture: pega scroll do window (mobile) e do .page-wrapper (desktop ≥990px)
            document.addEventListener('scroll', this._schedule, { passive: true, capture: true });
            this._update();
          } else {
            this._update(); // garante estado final após scroll rápido
            document.removeEventListener('scroll', this._schedule, { capture: true });
          }
        });
        this.intersectionObserver.observe(this);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        window.removeEventListener('resize', this._measure);
        document.removeEventListener('scroll', this._schedule, { capture: true });
        cancelAnimationFrame(this._frame);
      }

      _isMobile() {
        return matchMedia('(max-width: 749px)').matches;
      }

      _update() {
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--lp-scroll-gallery-offset')) || 0;
        const rect = this.getBoundingClientRect();
        let progress;
        if (this._isMobile()) {
          // começa só quando a seção está inteira na tela (base encostou no fim da viewport)
          // e termina quando o topo dela chega no header; antes disso fica parada na 1ª imagem
          const travel = window.innerHeight - offset - rect.height;
          progress = travel > 0 ? (window.innerHeight - rect.bottom) / travel : (offset - rect.top) / rect.height + 1;
        } else {
          progress = this._distance > 0 ? (offset - rect.top) / this._distance : 0;
        }
        progress = Math.min(Math.max(progress, 0), 1);
        this.style.setProperty('--lp-scroll-gallery-x', (progress * this._distance).toFixed(1));
      }
    }

    customElements.define('lp-scroll-gallery', LpScrollGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('main-banner-scroll')) {
    class MainBannerScroll extends HTMLElement {
      // campos no constructor (sem class fields) pra rodar no Safari/iOS antigo
      constructor() {
        super();
        this._frame = 0;
        this._onScroll = () => {
          if (this._frame) return;
          this._frame = requestAnimationFrame(() => {
            this._frame = 0;
            this._update();
          });
        };
      }

      connectedCallback() {
        this.spacer = this.querySelector('.main-banner-scroll__spacer');
        if (!this.spacer || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // só escuta scroll enquanto o banner está perto da viewport
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            // capture: pega scroll do window (mobile) e do .page-wrapper (desktop ≥990px scrolla ele, não o window)
            document.addEventListener('scroll', this._onScroll, { passive: true, capture: true });
            window.addEventListener('resize', this._onScroll, { passive: true });
            this._update();
          } else {
            this._update(); // garante estado final (0 ou 1) após scroll rápido
            this._removeListeners();
          }
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this._removeListeners();
        cancelAnimationFrame(this._frame);
      }

      _removeListeners() {
        document.removeEventListener('scroll', this._onScroll, { capture: true });
        window.removeEventListener('resize', this._onScroll);
      }

      _update() {
        const distance = this.spacer.offsetHeight;
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--main-banner-offset')) || 0;
        const scrolled = offset - this.getBoundingClientRect().top;
        const progress = distance > 0 ? Math.min(Math.max(scrolled / distance, 0), 1) : 1;
        this.style.setProperty('--main-banner-progress', progress.toFixed(3));
      }
    }

    customElements.define('main-banner-scroll', MainBannerScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["postcard-form"] && !Shopify.designMode) return;
  try {
    
  // Envio sem reload, só pro Google Sheets (Apps Script). Sem planilha configurada = erro.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('postcard-form__form')) return;

    event.preventDefault();
    if (form.dataset.sending) return;
    form.dataset.sending = 'true';

    const wrapper = form.closest('.postcard-form__right');
    const sheetUrl = wrapper?.dataset.sheetUrl;

    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('.postcard-form__status');
    const errorStatus = form.querySelector('.postcard-form__status-error');
    const buttonLabel = button?.textContent;

    const finish = (success) => {
      delete form.dataset.sending;
      if (button) {
        button.disabled = false;
        button.textContent = buttonLabel;
      }
      const target = success ? status : errorStatus;
      if (success) form.reset();
      if (target) {
        target.hidden = false;
        target.focus();
      }
    };

    if (button) {
      button.disabled = true;
      button.textContent = button.dataset.loadingLabel || buttonLabel;
    }
    if (status) status.hidden = true;
    if (errorStatus) errorStatus.hidden = true;

    const data = new FormData(form);

    if (!sheetUrl) {
      console.error('[postcard-form] URL da planilha não configurada');
      finish(false);
      return;
    }

    const payload = new URLSearchParams({
      nome: data.get('contact[name]') || '',
      email: data.get('contact[email]') || '',
      destinatario: data.get('contact[Email do destinatário]') || '',
      historia: data.get('contact[body]') || '',
      origem: data.get('contact[Origem]') || '',
      pagina: window.location.href,
    });

    try {
      await fetch(sheetUrl, { method: 'POST', mode: 'no-cors', body: payload });
    } catch (error) {
      console.error('[postcard-form] Falha ao enviar pra planilha', error);
      finish(false);
      return;
    }

    finish(true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stacked-panels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stacked-panels')) {
    class StackedPanels extends HTMLElement {
      // campos no constructor (sem class fields) pra rodar no Safari/iOS antigo
      constructor() {
        super();
        this._frame = 0;
        this._schedule = () => {
          if (this._frame) return;
          this._frame = requestAnimationFrame(() => {
            this._frame = 0;
            this._update();
          });
        };
      }

      connectedCallback() {
        // painel mais alto que a tela: gruda com top negativo, então o usuário vê ele inteiro
        // antes do próximo cobrir (senão a parte de baixo ficaria escondida)
        this.resizeObserver = new ResizeObserver(this._schedule);
        this.mutationObserver = new MutationObserver(() => this._observePanels());
        this.mutationObserver.observe(this, { childList: true });
        window.addEventListener('resize', this._schedule, { passive: true });
        this._observePanels();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        window.removeEventListener('resize', this._schedule);
        cancelAnimationFrame(this._frame);
      }

      _observePanels() {
        this.resizeObserver.disconnect();
        [...this.children].forEach((panel) => this.resizeObserver.observe(panel));
        this._schedule();
      }

      _update() {
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--stacked-panels-offset')) || 0;
        const viewport = window.innerHeight - offset;
        [...this.children].forEach((panel) => {
          const top = Math.min(0, viewport - panel.offsetHeight);
          panel.style.setProperty('--stacked-panel-top', `${top}px`);
        });
      }
    }

    customElements.define('stacked-panels', StackedPanels);
  }

  } catch(e) { console.error(e); }
})();
})();
